import React from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";

import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";

const ManageAgentModal = ({
  modalContent,
  handleClick,
  contentLabel,
  handleCancel,
  ...props
}) => {
  return (
    <Modal contentLabel={contentLabel}>
      <Div>
        <h2 style={{ marginBottom: "24px" }}>{modalContent.section_title}</h2>
        {convertStringToElements(modalContent.section_description)}
        <div style={{ marginTop: "56px" }}>
          <Button
            background={modalContent.buttons[0].type}
            onClick={handleClick}
          >
            {modalContent.buttons[0].text}
          </Button>
          <Button
            background={modalContent.buttons[1].type}
            onClick={handleCancel}
          >
            {modalContent.buttons[1].text}
          </Button>
        </div>
      </Div>
    </Modal>
  );
};

export { ManageAgentModal };

ManageAgentModal.propTypes = {
  modalContent: PropTypes.object.isRequired,
  contentLabel: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
};

const Div = styled.div`
  max-width: 438px;

  p {
    margin: 15px 0;
  }
`;
